module.exports = __webpack_public_path__ + "img/team_bastian.7b4caa71.png";